import React from 'react'

const Card = ({title, children, className}) => {
  return (
    <div
      className={`rounded border p-5 h-full ${className}`}
      style={{borderColor: '#ddd'}}
    >
      {
        title &&
        <h1 className="font-primary font-bold text-lg">{title}</h1>
      }
      {children}
    </div>
  )
}

export { Card }